import { render, staticRenderFns } from "./frequency-widget.html?vue&type=template&id=897cff9a&scoped=true&"
import script from "./frequency-widget.js?vue&type=script&lang=js&"
export * from "./frequency-widget.js?vue&type=script&lang=js&"
import style0 from "./frequency-widget.scss?vue&type=style&index=0&id=897cff9a&prod&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=897cff9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897cff9a",
  null
  
)

export default component.exports